import { format } from 'date-fns';

import type {
    HybrisTimeWindow,
    HybrisTimeWindowList,
    TimeWindowListWsDTO,
} from '../../models/hybris/hybrisTimeWindow';

import getDirectHybrisAxiosClient from '../clients/directHybrisAxiosClient';

const getTimeslotsForPostalCode = async ({
    userId,
    postalCode,
    days,
    availableDate,
}: {
    userId: string;
    postalCode: string;
    availableDate: Date;
    days?: number;
}) => {
    const client = getDirectHybrisAxiosClient();
    const response = await client.get<HybrisTimeWindowList>(
        `/users/${userId}/postcode/${encodeURIComponent(postalCode)}/timewindows`,
        {
            params: {
                numOfDays: days ? days.toFixed(0) : 30,
                availableDate: format(availableDate, 'yyyy-MM-dd'),
            },
        },
    );

    const timeslots = response.data;
    return timeslots;
};

const getTimeslotsForPointOfService = async ({
    userId,
    pointOfService,
    days,
    availableDate,
}: {
    userId: string;
    pointOfService: string;
    availableDate: Date;
    days?: number;
}) => {
    const client = getDirectHybrisAxiosClient();
    const response = await client.get<TimeWindowListWsDTO>(
        `/users/${userId}/pointofservice/${encodeURIComponent(pointOfService)}/timewindows`,
        {
            params: {
                numOfDays: days ? days.toFixed(0) : 30,
                availableDate: format(availableDate, 'yyyy-MM-dd'),
            },
        },
    );

    const timeslots = response.data;
    return timeslots;
};

const getTimeslots = async (
    userId: string,
    cartId: string,
    availableDate: Date,
    token?: string,
    days?: number,
) => {
    const client = getDirectHybrisAxiosClient(token);
    const response = await client.get<HybrisTimeWindowList>(
        `/users/${userId}/carts/${cartId}/timewindows`,
        {
            params: {
                numOfDays: days ? days.toFixed(0) : 30,
                availableDate: format(availableDate, 'yyyy-MM-dd'),
            },
        },
    );

    const timeslots = response.data;
    return timeslots;
};

const getCurrentTimeslot = async (userId: string, cartId: string, token?: string) => {
    const client = getDirectHybrisAxiosClient(token);
    const response = await client.get<HybrisTimeWindow>(
        `/users/${userId}/carts/${cartId}/timewindow`,
    );
    return response.data;
};

const selectTimeslot = async (
    timeslotId: string,
    userId: string,
    cartId: string,
    token?: string,
): Promise<void> => {
    const client = getDirectHybrisAxiosClient(token);
    await client.put(`/users/${userId}/carts/${cartId}/timewindow`, null, {
        params: { timeWindowId: timeslotId },
    });
};

export const timeslotsApi = {
    getTimeslots,
    selectTimeslot,
    getCurrentTimeslot,
    getTimeslotsForPointOfService,
    getTimeslotsForPostalCode,
};
